// Components
import { LegalPageContent } from '../../components/LegalPageContent/LegalPageContent';

export const CookiePolicyPage = () => {
  return <LegalPageContent slug="cookie-policy" fallbackTitle="Cookie Policy" />;
};
